import {
  animate,
  AnimationTriggerMetadata,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';

import { easing, timing } from './_configs';

export const fadeAnimation: AnimationTriggerMetadata = trigger('fade', [
  state('in', style({
    opacity: 1,
    visibility: 'visible'
  })),
  state('out', style({
    opacity: 0,
    visibility: 'hidden'
  })),
  transition('in <=> out', [
    animate(timing + easing)
  ])
]);

export const fadeTemplateAnimation: AnimationTriggerMetadata = trigger('fadeTemplate', [
  transition(':enter', [
    style({
      opacity: 0
    }),
    animate(timing + easing, style({
      opacity: 1
    }))
  ]),
  transition(':leave', [
    animate(timing + easing, style({
      opacity: 0
    }))
  ])
]);
